import React from 'react';
import { DealershipPicker } from '@makemydeal/dr-activities-dealership-picker';
import { Typography } from '@interstate/components/Typography';
import { ExclamationCircleIcon } from '@interstate/components/Icons/ExclamationCircleIcon';
import { Accordion, AccordionSummary } from '@interstate/components/AccordionGroup';
import {
    StyledAccordionContainer,
    StyledAccordionTitle,
    StyledAccordionHeader,
    StyledAccordionHeaderTitleContainer
} from '../Activity.style';
import type { DealershipSelectorProps } from '../../types/DealershipSelector';

export const DealershipSelector: React.FC<DealershipSelectorProps> = ({ value, onChangeDealership }) => {
    return (
        <StyledAccordionContainer>
            <Accordion className="custom-accordion" expanded={false} data-testid="vehicle-picker-accordion">
                <AccordionSummary chevronPosition="right" className="custom-accordion-summary-hide-icon">
                    <StyledAccordionHeader>
                        <StyledAccordionTitle>
                            <StyledAccordionHeaderTitleContainer>
                                <ExclamationCircleIcon />
                                <Typography variant="h6">Select Dealership</Typography>
                            </StyledAccordionHeaderTitleContainer>
                        </StyledAccordionTitle>
                        <DealershipPicker value={value} onChangeDealership={onChangeDealership} disabled={!!value} />
                    </StyledAccordionHeader>
                </AccordionSummary>
            </Accordion>
        </StyledAccordionContainer>
    );
};
